import React, { useState,useEffect } from 'react';
import { BlockStack, Card, Layout, Page, SkeletonBodyText, SkeletonPage } from "@shopify/polaris";
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import utils from '../../../../utils/utils'
import AppBridge from '../../../../utils/appBridge';
import intl from '../../../../i18n/intl';
const PrintOnDemandClass = () => {

  /**
   * 跳转 POD安装页面
   */
  const handleLink = () => {
    let podAppInstall = 'https://apps.shopify.com/printing-one-print-on-demand?source=DSM';

    try {
      const w = window.open('about:blank');
      w.location.href = podAppInstall;

    } catch (error) {
      window.open(podAppInstall, '_blank')
    }
  }

  const data =  {
    pageBg:{
        bg1:'/pod/whiteMask.png'
    },
    section1:{
        title:intl.get('Design and sell custom products online with print-on-demand dropshipping.'),
        dsc:intl.get('You only need to be responsible for product design and online store operations, and we do the rest of custom printing and order fulfillment.'),
        button: intl.get('Download Printing.one Free'),
        num:intl.get('20000+ installs in Shopify'),
        image:'/pod/pod_section1_img1.png'
    },
    section2:{
        title:intl.get('How does it work?'),
        list:[
            {
                icon:'/pod/partner_arrow_right_circle.png',
                image:'/pod/pod_section3_img1.png',
                title:intl.get('Pick and design your product'),
                dsc:intl.get('A variety of product templates and materials support you in product design.'),
                id:1
            },
            {
                icon:'/pod/partner_arrow_right_circle.png',
                image:'/pod/pod_section3_img2.png',
                title:intl.get('List the designed products to store'),
                dsc:intl.get('One-click listing of designed products to your Shopify store.'),
                id:2
            },
            {
                image:'/pod/pod_section3_img3.png',
                icon:'',
                title:intl.get("Manage your customers' orders"),
                dsc:intl.get('After the order is placed, we will customize and ship the product for you.'),
                id:3
            },
        ]
    },
     section3:{

        title:intl.get('Why choose Printing.one?'),
        list:[
            {
                id:1,
                image:'/pod/pod_section2_img1.png',
                title:intl.get('Build your own brand'),
                dsc:intl.get('Design your own products, hang your own logo, and create your own brand.')
            },
            {
                id:2,
                image:'/pod/pod_section2_img2.png',
                title:intl.get('Meet individual needs'),
                dsc:intl.get('Customize the products that customers want and make your products more popular.')
            },
            {
                id:3,
                image:'/pod/pod_section2_img3.png',
                title:intl.get('Low cost investment, low risk'),
                dsc:intl.get('No need to stock up, no inventory, extremely low cost input and extremely low risk.')
            },
        ],
    },
    section4:{
        title:intl.get('Start your online product design and customization business.'),
        button:intl.get('Download Printing.one Free')
    }
}
const router = useHistory();
const [loading,setLoading] = useState(false);
useEffect(() => {
  let isMount = false;
  if (!isMount) {
    setLoading(true)
    if(AppBridge && AppBridge.exist()) {
      AppBridge.setTitleBar('Print On Demand','/admin/customService')
    }
    setTimeout(() => {
      setLoading(false)
    }, 1000);
  }
  return () => {
    isMount = true
  };
}, []);
const initSkeletonPage = (
  <div>
    <SkeletonPage fullWidth={false}>
    <Layout>
          <Layout.Section>
          <Card>
          <BlockStack gap={400}>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          </BlockStack>
          </Card>
        </Layout.Section>
          </Layout>
    </SkeletonPage>
  </div>
);
  return loading ? initSkeletonPage :  (
    <Page
      title={AppBridge.exist() ? "" : <div style={{fontSize:'20px'}} >{intl.get("Printing.one: Print On Demand")}</div>}
      backAction={AppBridge.exist() ? undefined : {content: 'Printing.one: Print On Demand', onAction: () =>{utils.routeListen('/admin/customService')
      utils.routeJump1(router,'/admin/customService')}}}
      fullWidth={false}
    >
       <div className="pod_section1" style={{background: 'url(' + data.pageBg.bg1 + ') 50% 50% no-repeat'}}>
            <div className="pod_container" >
              <div className="pod_section1_box" >
                <div className="pod_section1_box_left">
                  <h1>{data.section1.title}</h1>
                  <div className="pod_section1_box_left_dsc">{data.section1.dsc}</div>
                  <div className="pod_button" onClick={()=>handleLink()}>{data.section1.button}</div>
                  <div className="pod_section1_box_left_num">{data.section1.num}</div>
                </div>
                <div className="pod_section1_box_right">
                  <img src={data.section1.image} alt={data.section1.title} />
                </div>
              </div>
            </div >
            </div>
          
            <div className="pod_section3" >
            <div className="pod_container">
              <div className="pod_section3_box">
                <h2>{data.section2.title}</h2>
                <div className="pod_section3_box_list">
                {data.section2.list.map((item,ind)=><div key={ind} className="pod_section3_box_item">
                  <img src={item.image} alt={item.title} />
                  <div className="pod_section3_box_item_content">
                  <h3>{item.title}</h3> 
                  <div>{item.dsc}</div>
                  </div>
                  {item.icon && <div className="pod_section3_box_item_icon">
                  <img src={item.icon} alt="dropshipman" />
                </div>}
                </div>)}
                </div>
              </div>
            </div >
            </div>
            
            <div className="pod_section2" style={{background: 'url(' + data.pageBg.bg1 + ') 50% 0% no-repeat'}}>
            <div className="pod_container">
              <div className="pod_section2_content">
                <h2>{data.section3.title}</h2>
                <div className="pod_section2_box">
                  <div className="pod_section2_box_right">
                  {data.section3.list.map(item=><div key={item.id} className='pod_section2_box_right_item'>
                  <div className="pod_section2_box_left">
                    <img src={item.image} alt={item.title} />
                  </div>
                    <div className="pod_section2_box_right_item_right">
                      <h3>{item.title}</h3>
                      <div>{item.dsc}</div>
                    </div>
                  </div>)} 
                  </div>
                </div>
              </div>
            </div >
            </div>
            <div className="pod_section4" style={{marginBottom:"24px"}}>
            <div className="pod_container">
            <div className="pod_section3_box_item_dsc">{data.section4.title}</div>
            <div className="pod_button" onClick={()=>handleLink()}>{data.section4.button}</div>
            </div>
            </div>
    </Page>
  );
}

export default PrintOnDemandClass;